import { render, staticRenderFns } from "./ChoosePocketPopup.vue?vue&type=template&id=2f4b6ea8&scoped=true"
import script from "./ChoosePocketPopup.vue?vue&type=script&lang=js"
export * from "./ChoosePocketPopup.vue?vue&type=script&lang=js"
import style0 from "./ChoosePocketPopup.vue?vue&type=style&index=0&id=2f4b6ea8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b6ea8",
  null
  
)

export default component.exports